import { Component, OnInit, Input, Output, EventEmitter, ViewChildren } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-addadjtype',
  templateUrl: './addadjtype.component.html',
  styleUrls: ['./addadjtype.component.css']
})
export class AddadjtypeComponent implements OnInit  {


  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading:boolean

  //Edit Get Values
  adjtypeColl: any = [];


  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Adjtype";

  adjtypeform = new FormGroup({
    adjtypeid: new FormControl(null),
    adjtypename: new FormControl('', Validators.required),
    inactive: new FormControl(false),
  });


  @Input() adjtypeid: number = 0;
  @Input() adjtypename: any = '';
  @Output() emitData = new EventEmitter();


  constructor(private toastr: ToastrService, private appService: DhukanDataService, private route: ActivatedRoute,
    private loginService: LoginDataService, private activeModal: NgbActiveModal, private confirmationDialogService: ConfirmationDialogService) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.adjtypeid = params.id
      }
    });
    this.fnServiceChanges();
  }


  fnServiceChanges() {
    
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
      if (this.loginService.fnCheckUser()) {

        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }

      }
      else {
        this.fnUserFailedForm();
      }
    }
    else {
      this.loginService.fnCompanyFaildRedirect();
    }
    });
  }
  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
      if (this.loginService.fnCheckUser()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }
    }
    else {
      this.loginService.fnCompanyFaildRedirect();
    }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  ngAfterViewInit() {
     this.loginService.fnSetFirstControlFocus('adjtypename');
  }
  fnOnInitForm() {
    try {

      this.adjtypeform.reset();
      this.fnInitializeAdjTypeFormGroup();

      if (this.adjtypeid > 0) {
        this.fngetAdjType();
      }



    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.adjtypeid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }
  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializeAdjTypeFormGroup() {
    this.adjtypeform.setValue({
      adjtypeid: 0,
      adjtypename: '',
      inactive: false,
    })
  }





  //Get 
  fngetAdjType() {
    var data = {
      'adjtypeid': this.adjtypeid,
      'companyid': this.loginService.fnGetCompanyId(),

    }
    this.appService.getAdjtype(data)
      .subscribe(
        (res) => {
          this.adjtypeColl = res.json().result;
          var editdata = this.adjtypeColl[0];
          this.fnEditMode(editdata);

        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }





  //Save Btn Click
  fnSaveBtnClick() {
    try {
      if(this.saveloading){
        return;
      }
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.adjtypeform.valid) {
        this.saveloading=true
        //Check
        var data = {
          'adjtypeid': this.adjtypeid,
          'adjtypename': this.adjtypeform.get('adjtypename').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'inactive': this.adjtypeform.get('inactive').value,
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }

        this.appService.fnCheckAdjtype(data).subscribe(
          (res) => {
            var _checkresult = res.json().result[0].checkfield;

            if (_checkresult === "done") {
              if (this.adjtypeform.get('adjtypeid').value > 0) {
                //Update Department
                this.fnSetAdjType(data);
              }
              else {
                //Insert Department
                this.fnInsertAdjType(data);
              }
            }
            else {
              if (_checkresult === "name") {
                this.saveloading=false
                this.adjtypeform.controls['adjtypename'].setErrors({ 'notfound': true });
              }
            }
          },
          (err) => {
            this.saveloading=false
            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading=false
      this.fnShowErrorMsg(ex);
    }
  }



  //Insert
  fnInsertAdjType(data) {

    this.appService.fnInsertAdjtype(data).subscribe(
      (res) => {
        this.saveloading=false
        if (res.json().status === 200) {

          var result = res.json().result;

          var adjtypeid = 0;
          if (result.length > 0) {
            adjtypeid = result[0].adjtypeid
          }

          this.fnInsertActivityLog('INSERT', 0, adjtypeid);

          this.toastr.success('', "The new adjtype has been added successfully.Insert Successfully");
          this.emitData.emit(adjtypeid);
          this.activeModal.close(true);

        }
      },
      (err) => {
        this.saveloading=false
        this.toastr.error('Error', err);
      });

  }


  //Set
  fnSetAdjType(data) {

    this.appService.fnSetAdjtype(data).subscribe(
      (res) => {
        this.saveloading=false
        if (res.json().result != "") {
          this.toastr.success('', "The Adjustment Type has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.adjtypeid, data.adjtypename);

          this.emitData.emit(this.adjtypeid);
          this.activeModal.close(true);;
        }
      },
      (err) => {
        this.saveloading=false
        this.toastr.error('Error', err);
      });

  }


  private fnEditMode(deptBO) {

    this.adjtypeform.setValue({
      adjtypeid: deptBO.adjtypeid,
      adjtypename: deptBO.adjtypename,
      inactive: deptBO.inactive,
    });


    this.isaddmode = false;
    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }



  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res)=>{
        },
        (err)=>{

        });

    } catch {

    }
  }

  public decline() {
    this.activeModal.close(false);
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }

}
